// extracted by mini-css-extract-plugin
module.exports = {"no-data":"ReadyToCheck_no-data__2I0kr"};